import Row from '../box/row';
import { ReactComponent as Back } from '../../../../assets/icons/arrowBack.svg';
import SizedBox from '../box/sizedBox';
import { LXh2 } from '../../texts/lxText';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';

const LXBack = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Row cursor="pointer" alignItems="center" onClick={() => navigate(-1)}>
      <Back></Back>
      <SizedBox width={8}></SizedBox>
      <LXh2>{theme.texts.back}</LXh2>
    </Row>
  );
};

export default LXBack;
